<template>
  <AisStateResults>
    <template v-slot="{ state: { hierarchicalFacetsRefinements } }">
      <ais-menu-select
        v-show="parent_filter ? hierarchicalFacetsRefinements[parent_filter].length > 0 : true"
        :class-names="{ 'ais-MenuSelect-select': 'form-select text-primary' }"
        :class="attribute"
        :attribute="attribute"
        :limit="20">
          <template v-slot:defaultOption>
            {{ default_option }}
          </template>
      </ais-menu-select>
    </template>
  </AisStateResults>
</template>

<script>
import { AisMenuSelect, AisStateResults } from 'vue-instantsearch/vue3/es';

export default {
  name: 'SearchFilter',
  props: {
    attribute: {
      type: String,
      required: true,
    },
    default_option: {
      type: String,
      required: true,
    },
    parent_filter: {
      type: String,
      default: null,
    },
  },
  components: {
    AisMenuSelect,
    AisStateResults,
  },
};
</script>
